import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import NoImage from "../../assets/images/noImage.jpg";
import { LogEvent } from "../../utils/firebase";
import {
  MdOutlineArrowForwardIos,
  MdOutlineArrowBackIos,
} from "react-icons/md";
import { Container } from "react-bootstrap";
import { settings } from "firebase/analytics";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { useRef } from "react";
import homeActions from "../../Redux/Home/action";
import { headertitle } from "../helper";

const BlogPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { homeBlogs } = useSelector(
    (state) => state.AuthReducer
  );
  const { currentLanguage } = useSelector((state) => state.commonReducer);
  const [blogList, setBlogList] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);
  const dispatch = useDispatch();

  const swiperRef = useRef(null);


  useEffect(() => {
    setBlogList([]);

    dispatch({
      type: homeActions.GET_HOME_CONTENTS,
      payload: {
        language_code: currentLanguage,
        type: headertitle.BLOG,
      },
    });
  }, [currentLanguage]);



  useEffect(() => {
    if (Array.isArray(homeBlogs)) {
      const filteredBlogs = homeBlogs.filter((item) =>
        item.language?.some(
          (lang) => lang.language_code === currentLanguage
        )
      ).sort(
        (a, b) =>
          new Date(b.created_at).getTime() -
          new Date(a.created_at).getTime()
      ).slice(0, 10);

      setBlogList(filteredBlogs);
      setTotalSlides(filteredBlogs.length);
    }
  }, [homeBlogs, currentLanguage]);




  const handleViewMore = () => {
    LogEvent("Home_Blogs_ViewAll");
    navigate("/blog");
  };

  const handleAfterChange = (current) => {
    setCurrentSlide(current);
  };



  return (
    <Container
      fluid
      className="farm-equipments"
      style={{ backgroundColor: "#F6F7FF" }}
    >
      <Container style={{ position: "relative" }}>
        <div
          style={{
            textAlign: "left",
            fontSize: "22px",
            color: "#232c63",
            margin: "20px 0px 30px 0px",
          }}
        >
          {t("Blogs")}
        </div>

        {blogList.length > 0 ? (
          <>
            <Swiper
              className="blog-swiper"
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={30}
              slidesPerView={3}
              navigation={false}
              pagination={{ clickable: true }}
              centeredSlides={true}
              loop={true}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
            >
              {blogList.map((blog, index) => (
                <SwiperSlide key={blog.id}>
                  <a
                    href={blog.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => LogEvent("Home_Blogs_Details")}
                  >
                    <img
                      style={{ width: "100%" }}
                      src={blog.img_url || NoImage}
                      alt=""
                    />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>

            <button
              className="custom-new-button"
              style={{
                backgroundColor: "#dc7f92",
                width: "45px",
                height: "45px",
                color: "#fff",
                borderRadius: "8px",
                border: "none",
                position: "absolute",
                top: "41%",
                left: "0%",
                zIndex: 5,
              }}
              onClick={() => swiperRef.current?.slidePrev()}
            >
              <MdOutlineArrowBackIos style={{ fontSize: "34px" }} />
            </button>

            <button
              className="custom-new-button"
              style={{
                backgroundColor: "#dc7f92",
                width: "45px",
                height: "45px",
                color: "#fff",
                borderRadius: "8px",
                border: "none",
                position: "absolute",
                top: "41%",
                right: "0%",
                zIndex: 5,
              }}
              onClick={() => swiperRef.current?.slideNext()}
            >
              <MdOutlineArrowForwardIos style={{ fontSize: "34px" }} />
            </button>


          </>
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "60px 20px",
              color: "#6c757d",
              fontSize: "18px",
              fontWeight: "500",
            }}
          >
            {t("No Data Found")}
          </div>
        )}
        {blogList.length > 0 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <div>
              <button
                className="btn btn-primary"
                style={{
                  backgroundColor: "#007bff",
                  borderColor: "#007bff",
                  color: "#fff",
                  position: "relative",
                }}
                onClick={handleViewMore}
              >
                {t("View More")}
              </button>
            </div>
          </div>
        )}
      </Container>
    </Container>
  );
};

export default BlogPage;
